/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountData } from './AccountData';
import {
    AccountDataFromJSON,
    AccountDataFromJSONTyped,
    AccountDataToJSON,
    AccountDataToJSONTyped,
} from './AccountData';

/**
 * 
 * @export
 * @interface ModificationResponse
 */
export interface ModificationResponse {
    /**
     * 
     * @type {Array<AccountData>}
     * @memberof ModificationResponse
     */
    created: Array<AccountData>;
    /**
     * 
     * @type {Array<AccountData>}
     * @memberof ModificationResponse
     */
    updated: Array<AccountData>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModificationResponse
     */
    deleted: Array<string>;
}

/**
 * Check if a given object implements the ModificationResponse interface.
 */
export function instanceOfModificationResponse(value: object): value is ModificationResponse {
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    return true;
}

export function ModificationResponseFromJSON(json: any): ModificationResponse {
    return ModificationResponseFromJSONTyped(json, false);
}

export function ModificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'created': ((json['created'] as Array<any>).map(AccountDataFromJSON)),
        'updated': ((json['updated'] as Array<any>).map(AccountDataFromJSON)),
        'deleted': json['deleted'],
    };
}

export function ModificationResponseToJSON(json: any): ModificationResponse {
    return ModificationResponseToJSONTyped(json, false);
}

export function ModificationResponseToJSONTyped(value?: ModificationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created': ((value['created'] as Array<any>).map(AccountDataToJSON)),
        'updated': ((value['updated'] as Array<any>).map(AccountDataToJSON)),
        'deleted': value['deleted'],
    };
}

